import { IListObjectStore } from '../../_common/type';
import { IJobHOCState } from '../../_core/job/types';
import { EMARPOLDocuments } from '../marpol/@types';
import { TBFL2A } from './groups/bfl2-a';
import { TBFL2B } from './groups/bfl2-b';
import { TBFL2C } from './groups/bfl2-c';
import { TBFL2D } from './groups/bfl2-d';
import { TBFL2E } from './groups/bfl2-e';
import { TBFL2F } from './groups/bfl2-f';
import { TBFL2G } from './groups/bfl2-g';
import { TBFL2H } from './groups/bfl2-h';
import { TBFL2I } from './groups/bfl2-i';

export enum EBFL2OperationState {
    RECORD = 'RECORD',
    PREVIEW = 'PREVIEW',
}

export enum EBFL2RecordState {
    APPROVED = 'APPROVED',
    STRIKED_OFF = 'STRIKED-OFF',
    SUBMITTED = 'SUBMITTED',
    IDLE = 'IDLE',
    EDIT = 'EDIT',
    VERIFIED = 'VERIFIED',
}

export type TBiofouling2Place =
    | {
          place: 'IN_PORT';
          portName: string;
      }
    | {
          place: 'AT_SEA';
          startPosition: { latitude: string; longitude: string };
          endPosition: { latitude: string; longitude: string };
      }
    | {
          place: 'AT_RECEPTION_FACILITY';
          receiptNumber: string;
          receiptAttachment: string;
          portName?: string;
          receptionFacilityName: string;
      };

export type TBFL2RecordUser = {
    name: string;
    designation: string;
    staffId: string;
    date: string;
};

export type TBFL2CommonFields = {
    selectedDate: string;
    remarks: string;
};

export type TBFL2CommonData = {
    id: string;
    /**
     * @description It's an ID for latest update for a document with given id.
     */
    _rev: string;
    marpolType: EMARPOLDocuments.BFL2;
    state: EBFL2RecordState;
    submittedBy?: TBFL2RecordUser;
    approvedBy?: TBFL2RecordUser;
    verifiedBy?: TBFL2RecordUser;
    strikedBy?: TBFL2RecordUser;
    strikeOffReason?: string;
    editVersions?: TBFL2BackendRecord[];
    dateOfApprovedRecordEdit?: string;
    _attachments?: object;
};

export enum EBFL2RecordCode {
    BFL2A1 = 'BFL2-A1',
    BFL2B1 = 'BFL2-B1',
    BFL2C1 = 'BFL2-C1',
    BFL2D1 = 'BFL2-D1',
    BFL2E1 = 'BFL2-E1',
    BFL2F1 = 'BFL2-F1',
    BFL2G1 = 'BFL2-G1',
    BFL2H1 = 'BFL2-H1',
    BFL2I1 = 'BFL2-I1',
    BFL2I2 = 'BFL2-I2',
}

export type TBFL2Record =
    | TBFL2A
    | TBFL2B
    | TBFL2C
    | TBFL2D
    | TBFL2E
    | TBFL2F
    | TBFL2G
    | TBFL2H
    | TBFL2I;

export type TBFL2CurrentOperationAlert = {
    id: string;
    type:
        | 'WARNING'
        | 'ERROR'
        | 'INFO'
        | 'REQUIRED_FIELD'
        | 'OBSERVED_QUANTITY_ALERT';
    title: string;
    subtitle: string;
    message: string;
    listOfItems?: {
        title: string;
        subtitle?: string;
        message?: string;
        link?: string;
    }[];
    action?: {
        title: string;
        link: string;
    };
};

export type TBFL2BackendRecord = TBFL2Record & {
    submittedBy: TBFL2RecordUser;
    approvedBy?: TBFL2RecordUser;
    verifiedBy?: TBFL2RecordUser;
    strikedBy?: TBFL2RecordUser;
    editedBy?: TBFL2RecordUser;
    isAutoCreated?: boolean;
    isEditWarningVisible?: boolean;
};

export enum EBFL2EditMode {
    GENERAL = 'GENERAL',
    APPROVED_EDIT = 'APPROVED_EDIT',
}

export type TBFL2CurrentOperation = {
    recordCode: EBFL2RecordCode;
    operationState: EBFL2OperationState;
    formData: TBFL2Record;
    validationAlerts: IListObjectStore<TBFL2CurrentOperationAlert>;
    editMode?: EBFL2EditMode;
};

export type TBFL2HistoryFilters = {
    startDate: any;
    endDate: any;
    shownRecords: 'ALL' | 'ALL-PENDING';
    state?: EBFL2RecordState | string;
    sortOrder?: 'asc' | 'desc';
	vesselId?: string;
};

export interface IBFL2Store extends IJobHOCState {
    records: IListObjectStore<TBFL2BackendRecord>;
    currentOperation?: TBFL2CurrentOperation;
    filter: TBFL2HistoryFilters;
}
